import React from 'react';
import CommonWrap from '../common-wrap';


const AttachmentWrap = () => {
    const tabs = [ { id: '1', tab: '任务附件'},{ id: '2', tab: '稿件附件'} ];
    const title = '附件池';
    return(
        <CommonWrap tabs={tabs} title={title}/>
    ) 
}


export default AttachmentWrap